import { render, staticRenderFns } from "./AsociacionGrid.vue?vue&type=template&id=cf36b8ec&"
import script from "./AsociacionGrid.vue?vue&type=script&lang=ts&"
export * from "./AsociacionGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports